module.exports = __webpack_public_path__ + "img/ms-excel.14bdaa00.png";